module.exports = __webpack_public_path__ + "static/wire-product-1-7d8725dbabf67ab1f87565bdcfa49122.png";